import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecureStorageService } from 'src/app/service/secure-storage.service';
import { AccessControlService } from 'src/app/service/access-control.service';
import { SubscriptionPlanId } from 'src/app/config/subscription-plans';
import { environment } from 'src/environments/environment';

export const authGuard: CanActivateFn = async (route, state) => {
  const secureStorage = inject(SecureStorageService);
  const router = inject(Router);
  const accessControl = inject(AccessControlService);

  const token = await secureStorage.getItem('user_token');

  if (!token) {
    router.navigate(['/login']);
    return false;
  }

  const modulo = route.data?.['modulo'];
  if (modulo && environment.modulos?.[modulo] === false) {
    return router.createUrlTree(['/dashboard']);
  }

  //const api_status = await userService.getApiStatus();

  // if (!api_status) {
   // router.navigate(['/update']);
   // return false;
  //}

  if (route.data?.['allowExpiredAccess'] === true) {
    return true;
  }

  const access = await accessControl.getAccessState();

  if (access.hasAccess) {
    const minimumPlan = route.data?.['minimumPlan'] as SubscriptionPlanId | undefined;
    if (minimumPlan) {
      const featureName = String(route.data?.['planFeatureName'] || 'Este recurso');
      const canUsePlanFeature = await accessControl.canUsePlanFeature(featureName, minimumPlan);
      return canUsePlanFeature || router.createUrlTree(['/dashboard']);
    }

    return true;
  }

  await accessControl.canUseFeature('o Construfácil');
  return router.createUrlTree(['/dashboard']);
};
